import { render, staticRenderFns } from "./PaymentsProcessed.vue?vue&type=template&id=046d881c&scoped=true&"
import script from "./PaymentsProcessed.vue?vue&type=script&lang=ts&"
export * from "./PaymentsProcessed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d881c",
  null
  
)

export default component.exports